import { z } from 'zod';
export const apiHatasi = z.object({
    durum: z.number().int(),
    kod: z.string(),
    mesaj: z.string(),
    ayrintilar: z.unknown().optional(),
});
//# sourceMappingURL=hata.js.map